import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.regexp.to-string";
import get from "lodash/get";
import { addDays, fromUnixTime, isAfter, isValid, getUnixTime } from "date-fns";
import kebabCase from "lodash/kebabCase";
import { interactionCard, interaction } from "@origin-digital/reporting-client";
import { FEATURES } from "@origin-digital/native-features";
import { isNative } from "@origin-digital/platform-helpers";
export var mockProps = {
  content: {
    heading: "Tips to make your move easier",
    headingIconSha: undefined,
    iconSvg: "",
    subHeading: "Tasks you can do online:",
    subHeadingWeight: "medium",
    item1: "Redirect your post",
    item2: "Book a removal van",
    item3: "Update your online accounts",
    hideCTA: false,
    buttonLink: "/blog/lifestyle/7-online-tasks-to-make-moving-house-easier.html",
    buttonText: "View full article",
    buttonKind: "secondary",
    newTab: true,
    enableAppStore: false,
    appStoreLink: undefined,
    enablePlayStore: false,
    playStoreLink: undefined,
    terms: "",
    isDismissable: false,
    dismissDuration: undefined
  }
};
export var handleHide = function handleHide(experienceId, setShowDismissMessage) {
  if (experienceId) {
    localStorage.setItem(getDismissedKey(experienceId), getUnixTime(new Date()).toString());
  }

  setShowDismissMessage(true);
};
export var undoHide = function undoHide(experienceId, setShowDismissMessage) {
  return function () {
    if (experienceId) {
      localStorage.removeItem(getDismissedKey(experienceId));
    }

    setShowDismissMessage(false);
  };
};
export var getInititalShowState = function getInititalShowState(currentDate, content) {
  if (get(content, "experienceId") && get(content, "isDismissable")) {
    var key = getDismissedKey(content.experienceId);
    var wasDismissed = localStorage.getItem(key);
    var dismissDuration = get(content, "dismissDuration");

    if (!dismissDuration) {
      return !wasDismissed;
    }

    var dismissedDate = fromUnixTime(Number(wasDismissed));

    if (!isValid(dismissedDate)) {
      localStorage.removeItem(key);
      return true;
    }

    var endDate = addDays(dismissedDate, Number(dismissDuration));
    var expired = isAfter(currentDate, endDate);

    if (expired) {
      localStorage.removeItem(key);
    }

    return expired;
  }

  return true;
};
export var getDismissedKey = function getDismissedKey(experienceId) {
  return experienceId + "_wasDismissed";
};
export var foreverMessage = "We'll hide this message.";
export var generateDismissMessage = function generateDismissMessage(dismissDuration) {
  var timeIncrement = dismissDuration > 1 ? "days" : "day";
  return dismissDuration ? "We'll hide this message for ".concat(dismissDuration, " ").concat(timeIncrement, ".") : foreverMessage;
};
export var sendInteractionEvent = function sendInteractionEvent(label, experienceId, context) {
  var cardName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "Cross sell";
  return function () {
    if (context === "dashboard") {
      var idCardName = kebabCase(cardName);
      interactionCard("click", {
        appName: "".concat(idCardName, ":widget"),
        card: {
          category: "dashboard-card",
          id: "card-".concat(idCardName, "-").concat(experienceId),
          primaryCta: label,
          title: "My Account - ".concat(experienceId, " ").concat(cardName, " Card")
        },
        label: label
      });
    } else {
      interaction("click", {
        id: "next-best-action-button",
        label: label,
        componentType: "link"
      });
    }
  };
};
export var CLOUDINARY_ENDPOINT = "https://res.cloudinary.com/originenergy/image/upload";
export var getCloudinaryUrl = function getCloudinaryUrl(imageSha) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 192;
  var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 192;
  var formatAuto = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var quality = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 100;
  return "".concat(CLOUDINARY_ENDPOINT, "/q_").concat(quality).concat(formatAuto ? ",f_auto" : "", ",c_scale,w_").concat(width, ",h_").concat(height, "/").concat(imageSha);
};
var EVENT_DISPATCH_PREFIX = "navTo.";
export var shouldUseEventDispatch = function shouldUseEventDispatch(buttonLink) {
  return buttonLink && buttonLink.indexOf(EVENT_DISPATCH_PREFIX) === 0;
};
export var getAppNameForNavTo = function getAppNameForNavTo(buttonLink) {
  return buttonLink.substring(EVENT_DISPATCH_PREFIX.length);
};
var featureRequirements = {
  directDebitSetUp: FEATURES.navModal
};
export var isRequiredFeatureAvailable = function isRequiredFeatureAvailable(features, buttonLink) {
  if (!isNative()) {
    return true;
  }

  var appName = getAppNameForNavTo(buttonLink);
  var requirement = featureRequirements[appName];
  return requirement ? !!features[requirement] : true;
};